export const API_URLS = {
  DynamoDB_TABLE_DATA: 'https://nly80j4xhd.execute-api.eu-west-1.amazonaws.com/dev/data',
  S3_DATA: 'https://f6eru5lajg.execute-api.eu-west-1.amazonaws.com/dev/data',
  DOWNLOAD_FILE: 'https://f6eru5lajg.execute-api.eu-west-1.amazonaws.com/dev/data',
  S3_UPLOAD: 'https://jaxdjmsjxi.execute-api.eu-west-1.amazonaws.com/dev/data',
  USER_ROLE: 'https://nly80j4xhd.execute-api.eu-west-1.amazonaws.com/dev/data',
  USER_ROLE_v2 : 'https://nly80j4xhd.execute-api.eu-west-1.amazonaws.com/dev/data',
};

export const S3_CONFIG = {
  BUCKET_1: 'finance-consolidation-sample-files',
  BUCKET_2: 'finance-consolidation-dynamodb',
  KEY_Dynamodb: 'DynamoDB-Sync/PortalDataDump_PROD.json',
  KEY_Dynamodb_Dev: 'DynamoDB-Sync/PortalDataDump.json',
  KEY_File: 'Master Template Files/',
  KEY_File_Dev : 'Master Template Files/dev/'
};
